import React, { useEffect, useState } from "react";
import { getBulkOrders } from "../../api/BulkorderService";
import { getErrorMessage } from "../../utils/errorHandler";
import { useNavigate } from "react-router-dom";
import Pagination from "../Pagination/Pagination";
import { FaEye } from "react-icons/fa";
import DateFormat from "../../utils/DateFormat";

export default function BulkOrderList() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const navigate = useNavigate();

  const loadData = async () => {
    try {
      setLoading(true);

      const res = await getBulkOrders(currentPage, itemsPerPage);

      const data = Array.isArray(res?.data) ? res.data : [];
      const pagination = res?.pagination || {};

      setList(data);

      setTotalItems(
        pagination?.totalItems || pagination?.totalitems || data.length || 0,
      );

      setErrorMessage("");
    } catch (err) {
      setErrorMessage(getErrorMessage(err));
      setList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [currentPage]);

  if (loading) {
    return (
      <div className="d-flex vh-100 align-items-center justify-content-center">
        <p className="m-0">Loading Bulk Orders...</p>
      </div>
    );
  }

  return (
    <div className="container-fluid p-4 np-bulk-orders-page">
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Bulk Order List</h5>
      </div>

      <div className="card p-3">
        <table className="table table-bordered table-hover">
          <thead className="bg-light">
            <tr>
              <th className="text-dark fw-bold">#</th>
              <th className="text-dark fw-bold">Company Name</th>
              <th className="text-dark fw-bold">Email</th>
              <th className="text-dark fw-bold">Phone</th>
              <th className="text-dark fw-bold">Project Type</th>
              <th className="text-dark fw-bold">Created At</th>
              <th className="text-dark fw-bold">Status</th>
              <th className="text-dark fw-bold text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {list.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-center">
                  No Bulk Orders Found
                </td>
              </tr>
            ) : (
              list.map((item, index) => (
                <tr key={item._id || index}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>

                  <td>{item.companyName || "-"}</td>
                  <td>{item.email || "-"}</td>
                  <td>{item.phoneNo || "-"}</td>
                  <td>{item.projectType || "-"}</td>
                  <td>
                      <DateFormat date={item.createdAt} />
                  </td>
                  <td>{item.status || "-"}</td>

                  <td className="text-center np-table-actions">
                    <FaEye
                      className="np-table-action-icon"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate("/bulk-order/view", {
                          state: {
                            bulkOrderId: item._id,
                          },
                        })
                      }
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </div>
  );
}
